/**
 * @author Harshitha.k
 * @description 
 */

import './CSS/Panel.css';
import React, { useEffect, useState } from 'react';
import Graph from './Graph';
import { Drawer } from 'antd';
import orderBy from 'lodash.orderby';
import { connect } from 'react-redux';
import { FullscreenOutlined } from '@ant-design/icons';
import { Responsive, WidthProvider } from 'react-grid-layout';

import { Title } from './CSS/styles.js';
import 'react-grid-layout/css/styles.css';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const Panel = (props) => {
  const [visiblePanels, setVisiblePanels] = useState({});
  const [translationCacheState, setTranslationCache] = useState(props.translationCache || {});
  const [selectedThemeing] = useState(props.selectedThemeing);
  const [selectedTheme] = useState(props.selectedTheme);
  const [drawerState, setDrawerState] = useState({});

  const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
  const panelTitleBg = props && props.themeValue && props.themeValue.customComponent && props.themeValue.customComponent.Dashboard && props.themeValue.customComponent.Dashboard.panelTitleBg;

  useEffect(() => {
    if (props.translationCache !== translationCacheState) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  useEffect(() => {
    props.panels.forEach((panelObject) => {
      visiblePanels[panelObject.id] = false;
    });
    setVisiblePanels(visiblePanels);
  }, [props.panels]);

  const getTranslation = (keyword) => {
    return props.translationCache && props.translationCache[keyword]
      ? props.translationCache[keyword]
      : keyword;
  };

  const getPanels = (panels, dashboardName, theme, theming, headerJSON) => {
    let divWidth = props.divWidth
      ? window.innerWidth - props.divWidth - 30
      : window.innerWidth - 100;
    divWidth = window.innerWidth;

    panels = orderBy(panels, ['position.y'], ['asc']);
    let prevx = 0,
      prevw = 0,
      prevy = 0,
      percent,
      actualwidth;
    let data =
      panels &&
      Array.isArray(panels) &&
      panels.map((value, index) => {
        let { x, y, w, h } = value.position;
        if (prevy !== y) {
          prevw = 0;
          prevx = 0;
        }
        if (divWidth < 1434 && divWidth >= 1368) {
          percent = (w * 100) / 1200;
          percent = Math.floor(percent * 100);
          actualwidth = (percent / 10) * 1.2;
          w = actualwidth;
          x = prevx + prevw;
          prevx = x;
          prevw = actualwidth;
          prevy = y;
        } else if (divWidth < 1299 && divWidth >= 1224) {
          percent = (w * 100) / 1000;
          percent = Math.floor(percent * 100);
          actualwidth = (percent / 10) * 1;
          w = actualwidth;
          x = prevx + prevw;
          prevx = x;
          prevw = actualwidth;
          prevy = y;
        } else if (divWidth < 1224 && divWidth >= 1000) {
          percent = (w * 100) / 1000;
          percent = Math.floor(percent * 100);
          actualwidth = (percent / 10) * 0.825;
          w = actualwidth;
          x = prevx + prevw;
          prevx = x;
          prevw = actualwidth;
          prevy = y;
        } else if (divWidth < 1000 && divWidth >= 801) {
          percent = (w * 100) / 1000;
          percent = Math.floor(percent * 100);
          actualwidth = (percent / 10) * 0.5;
          w = actualwidth;
          x = prevx + prevw;
          prevx = x;
          prevw = actualwidth;
          prevy = y;
        } else if (divWidth <= 800) {
          w = 12;
        }

        value.dashboardName = dashboardName;
        const styles = {
          fontWeight: 'bold',
          backgroundColor: panelTitleBg
        };
        const fullScreenStyle = {
          marginTop: '-37px',
          float: 'right'
        };
        let showTitle = props && props.headerJSON && props.headerJSON.isChildren && props.headerJSON.isChildren === true ? false : true;
        return (
          <div
            style={{ background: themeBackground }}
            key={dashboardName + index}
            data-grid={{ x, y, w, h, isResizable: true }}>
            <div>
              {
                showTitle ? <Title className="headerdrag" style={styles}>
                  {getTranslation(value.title)}
                </Title> : null
              }

              <FullscreenOutlined
                style={fullScreenStyle}
                type="fullscreen"
                className="editsettings"
                title="fullscreen"
                onClick={() => {
                  if (value.enableWarningsOnFS) {
                    props.navigate(
                      `/rubus/WarningDashboard?Name=${dashboardName}&&PanelId=${value.id}`
                    );
                  } else {
                    setDrawerState((prev) => ({ ...prev, [value.id]: true }));
                  }
                }}
              />
            </div>

            <Graph
              key={'graph' + dashboardName + index}
              graphprops={{ ...value, ...headerJSON }}
              {...props}
            />
            <div key={dashboardName + index}>
              <Drawer
                id={`${dashboardName}${index}`}
                title={value.title}
                centered
                closable
                width="90%"
                open={drawerState[value.id]}
                onOk={() => setDrawerState((prev) => ({ ...prev, [value.id]: true }))}
                onClose={() => setDrawerState((prev) => ({ ...prev, [value.id]: false }))}
                footer={null}>
                <Graph
                  key={'graph' + dashboardName + index}
                  graphprops={{ ...value, ...headerJSON }}
                  {...props}
                />
              </Drawer>
            </div>
          </div>
        );
      });

    return data;
  };

  return (
    <ResponsiveReactGridLayout
      className="layout"
      draggableHandle=".headerdrag"
      rowHeight={30}
      style={{
        width:
          props.navigationMode === 'side'
            ? props.divWidth
              ? window.innerWidth - props.divWidth - 30
              : window.innerWidth - 100
            : undefined
      }}>
      {getPanels(
        props.panels,
        props.dashboardName,
        selectedTheme,
        selectedThemeing,
        props.headerJSON
      )}
    </ResponsiveReactGridLayout>
  );
};
const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    selectedTheme: state.ThemeReducer.theme,
    selectedThemeing: state.ThemeReducer.themeing
  };
};
export default connect(mapStateToProps)(Panel);
